import { render, staticRenderFns } from "./SimpleTileItem.vue?vue&type=template&id=b17ae02c"
import script from "./SimpleTileItem.vue?vue&type=script&lang=js"
export * from "./SimpleTileItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports